import { Component, Input } from '@angular/core';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { MaterialModule } from '../../material.module';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-information-note',
  standalone: true,
  imports: [SvgIconComponent, MaterialModule,CommonModule],
  templateUrl: './information-note.component.html',
  styleUrl: './information-note.component.scss',
})
export class InformationNoteComponent {
  @Input() message: any;
  @Input() isFrom!: string;
  @Input() mode!: string;
}